var api = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../node_modules/css-loader/index.js??ruleSet[1].rules[0].use[1]!../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[0].use[2]!./index.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"attributes":{"spm-webpack-bundled":true}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};